import AuthBusiness from "@/business/AuthBusiness.js";
import FrontBusiness from "@/business/FrontBusiness.js";
import TextParser from "@/business/livros/TextParser.js";
import Http from "@/commons/Http";
import ValidationUtils from "@/commons/ValidationUtils.js";
import Utils from "@/commons/Utils";
import ChecklistProcessamentoBusiness from "@/business/ChecklistProcessamentoBusiness";
import moment from "moment";
const path = 'api/notificacao';

export default {

  categoriasNotificacao: Object.freeze([
    {id:'NOTIFICACAO',nome:'Notificação'},
    {id:'AUTUACAO',nome:'Autuação'},
  ]),

  baixarNotificacao(notificacao){
    return `${path}/${notificacao}/pdf`;
  },

  nomearEntidade(notificacao, code = true){
    return `Notificação ${code ? FrontBusiness.formatarCodigo(notificacao?.numero) +'/'+ notificacao?.ano: ''}`;
  },

  nomearNotificacao(notificacao){
    return `Notificação${notificacao.atribuicao ? ' ' + notificacao.atribuicao : ''} ${notificacao.codigo}` +
      (notificacao.tipoCategoria === 'AUTUACAO' ? `/${notificacao.ano}` : '');
    },

  async pagination(sort, direction, page, size, filters = {}){
    return Http.post(`${path}/pagination?sort=${sort || 'o.cadastro'},${direction || 'desc'}&page=${page || 1}&size=${size || 10}`, filters);
  },

  paginationExcel(sort, direction, page, size, filters = {}){
    return `${path}/pagination/export-excel?sort=o.cadastro,desc&page=${page || 1}&size=${size || 10}`;
  },

  async paginationV2(sort, direction, page, size, filters = {}){
    return Http.post(`${path}/v2/pagination?sort=${sort || 'o.cadastro'},${direction || 'desc'}&page=${page || 1}&size=${size || 10}`, filters);
  },

  paginationExcelV2(sort, direction, page, size){
    return `${path}/v2/pagination/export-excel?sort=${sort || 'o.cadastro'},${direction || 'desc'}&page=${page || 1}&size=${size || 10}`;
  },

  async getById(indicador){
    return Http.get(`${path}/${indicador}`);
  },

  async buscarRegistrosTds(id) {
    return Http.get(`${path}/${id}/registros-tds`);
  },

  async buscarMatriculas(id) {
    return Http.get(`${path}/${id}/matriculas`);
  },

  async listarDetalhesAtoRegistroTDNotificacao(id){
    return Http.get(`${path}/registros-td/${id}`);
  },

  async listarDetalhesAtoRegistroTDNotificacaoImagem(id){
    return Http.get(`${path}/registros-td/imagem/${id}`);
  },


  async save(dto, id = ''){
    return Http.post(`${path}/${id}`, dto);
  },

  async saveForm(dto, id = ''){
    return Http.post(`${path}/form/${id}`, dto);
  },

  salvarAdiamento(notificacao, dto) {
    return Http.post(`${path}/${notificacao}/salvar-adiamento`, dto);
  },

  async getAuditorias(id, page, size){
    return Http.get(`${path}/${id}/auditorias?page=${page || 1}&size=${size || 10}`);
  },

  async vinculos(id){
    return Http.get(`${path}/${id}/vinculos`);
  },

  async buscarPorCodigos(codigos) {
    if(!ValidationUtils.validateLongArray({values: codigos, min: 0, max: 99999999})){
      throw 'Intervalo Inválido';
    }
    return await Http.post(`${path}/codigos`, codigos);
  },

  async copilarTemplate(template, notificacao = {}, debug = {}){

    const dicionario = {
      checklist : {},
      notificacao:{
        codigo : notificacao.codigo,
        texto : notificacao.texto,
        cadastro : notificacao.cadastro
      }
    };

    await AuthBusiness.getLoggedUser().then(logged => dicionario.usuarioLogado = { ...logged, senha : undefined });

    // INDICES
    if (notificacao.indices != null) {
      Object.keys(notificacao.indices).forEach(i => {
        dicionario.checklist[i] = notificacao.indices[i];
        dicionario.checklist[i.toUpperCase()] = notificacao.indices[i];
        dicionario.checklist[i.toLowerCase()] = notificacao.indices[i];
      });
    }

    for(let eI in notificacao.envolvidos){
      await TextParser.copilarDicionarioEnvolvido(notificacao.envolvidos[eI], dicionario.checklist.envolvidos?.[eI]);
    }

    dicionario.notificacao.envolvidos = notificacao?.envolvidos?.map(env => {
      if (typeof env.enderecos === 'string') {
        env.enderecos = JSON.parse(env.enderecos);
      }
      env?.enderecos?.map(e => {
        e.diligencias = e.diligencias || [];
        if (typeof e.diligencias === 'string') {
          e.diligencias = JSON.parse(e.diligencias);
        }
        return e;
      })
      return env;
    });
    // Protocolos com atribuição derivada
    dicionario.notificacao.protocolos = (notificacao?.protocolos || []).map(prot => ({
      ...prot,
      atribuicao: prot.dominio ? prot.dominio.replace('PROTOCOLO_', '').replace('CERTIDAO_', '') : null,
      cadastro: prot.dataCadastro || prot.cadastro
    }));
    const matriculasEnriquecidas = await this.buscarMatriculas(notificacao.id).catch(() => null);
    dicionario.notificacao.matriculas = matriculasEnriquecidas || notificacao?.matriculas;
    dicionario.notificacao.enderecos = notificacao?.enderecos;

    // Registros TD: busca do backend inclui vínculos diretos + protocolos RTD vinculados
    const registrosTdsEnriquecidos = await this.buscarRegistrosTds(notificacao.id).catch(() => null);
    dicionario.notificacao.registrosTds = registrosTdsEnriquecidos || (notificacao?.registrosTds || []).map(rt => ({
      ...rt,
      livro: rt.livroNumero || rt.livro,
      folha: rt.livroFolha || rt.folha
    }));

    // Detalhes de imagem dos registros TD (separado da lista)
    const registrosTdsDetalhes = await this.listarDetalhesAtoRegistroTDNotificacao(notificacao.id).catch(e => null);
    dicionario.notificacao.imagens = await this.listarDetalhesAtoRegistroTDNotificacaoImagem(notificacao.id).catch(e => null);
    if (registrosTdsDetalhes) {
      if (registrosTdsDetalhes.selagem) registrosTdsDetalhes.selagem = moment(registrosTdsDetalhes.selagem).format('DD/MM/YYYY');
      if (registrosTdsDetalhes.registro) registrosTdsDetalhes.registro = moment(registrosTdsDetalhes.registro).format('DD/MM/YYYY');
      dicionario.notificacao.registrosTdsDetalhes = registrosTdsDetalhes;
    }

    // Diligências como lista flat
    const diligenciasLista = [];
    (notificacao?.envolvidos || []).forEach(env => {
      const enderecos = typeof env.enderecos === 'string' ? JSON.parse(env.enderecos) : (env.enderecos || []);
      enderecos.forEach(end => {
        const diligencias = typeof end.diligencias === 'string' ? JSON.parse(end.diligencias) : (end.diligencias || []);
        const enderecoCompleto = [end.cep, end.logradouro, end.numero, end.bairro, end.cidade, end.estado]
          .filter(v => v != null && v !== '').join(', ');
        diligencias.forEach(dig => {
          const dataObj = dig.data ? new Date(dig.data) : null;
          diligenciasLista.push({
            data: dig.data,
            hora: dataObj ? `${String(dataObj.getHours()).padStart(2, '0')}:${String(dataObj.getMinutes()).padStart(2, '0')}` : null,
            formaNotificacao: dig.formaNotificacao,
            tipoResultado: dig.tipoResultado?.nome || dig.tipoResultado,
            detalhes: dig.detalhes,
            notificador: dig.usuarioNotificador?.nome || dig.notificador,
            endereco: enderecoCompleto
          });
        });
      });
    });
    if (diligenciasLista.length > 0) {
      dicionario.diligencias = diligenciasLista;
    }

    // Notificado filtrado por papel
    const notificadoEnv = (notificacao?.envolvidos || []).find(env =>
      env.papel && env.papel.toLowerCase() === 'notificado'
    );
    if (notificadoEnv) {
      const pessoa = notificadoEnv.indicadorPessoalVersao || notificadoEnv;
      const nome = pessoa.nome || notificadoEnv.nome;
      const doc = pessoa.cpfCnpj || pessoa.documento || notificadoEnv.documento;
      const tipoPessoa = pessoa.tipoPessoa || notificadoEnv.tipoPessoa;
      dicionario.notificado = {
        nome: nome,
        documento: doc,
        cpfCnpj: doc,
        cpf: tipoPessoa === 'FISICA' ? doc : null,
        cnpj: tipoPessoa === 'JURIDICA' ? doc : null
      };
    }

    // Endereço(s) no nível da notificação
    const todosEnderecos = [];
    (notificacao?.envolvidos || []).forEach(env => {
      const enderecos = typeof env.enderecos === 'string' ? JSON.parse(env.enderecos) : (env.enderecos || []);
      enderecos.forEach(end => todosEnderecos.push(end));
    });
    if (todosEnderecos.length > 0) {
      const buildEndereco = (end) => ({
        cep: end.cep,
        logradouro: end.logradouro,
        numero: end.numero,
        bairro: end.bairro,
        cidade: end.cidade,
        estado: end.estado,
        complemento: end.complemento,
        completo: [end.cep, end.logradouro, end.numero, end.bairro, end.cidade, end.estado]
          .filter(v => v != null && v !== '').join(', ')
      });
      dicionario.endereco = buildEndereco(todosEnderecos[0]);
      dicionario.enderecos = todosEnderecos.map(buildEndereco);
    }

    const callback = async (nodes = [], dicionario = {}, debug = undefined) => {

      let output = '';

      for(let pos in nodes){

        let node = nodes[pos];
        let debugNode = { tipo : node.name, nodes : [], params : node.params, dicionario : dicionario };
        output += await TextParser.commonsParse(node, dicionario, callback, debugNode);

        // if(debug){
        //   debugNode.conteudo = TextParser.htmlText(node.body);
        //   debugNode.output = Utils.clone(output);
        //
        //   if(debugNode.tipo || debugNode.conteudo){
        //     debug?.nodes.push(Utils.clone(debugNode));
        //   }
        // }

      }

      return output;
    };

    await TextParser.init();
    return TextParser.parse(template, callback, dicionario);

  },

  async clonar(id) {
    return Http.post(`${path}/${id}/clonar`);
  },

  getResultadosNotificacao() {
    return [
      {id : 'POSITIVA', nome : 'Positiva'},
      {id : 'NEGATIVA', nome : 'Negativa'},
      {id : 'PARCIAL', nome : 'Parcial'},
      {id : 'CANCELADA', nome : 'Cancelada'},
    ]
  },

  getFormasNotificacao() {
    return [
      {id : 'NOTIFICADOR', nome : 'Notificador'},
      {id : 'CARTA_AR', nome : 'Carta AR'},
    ]
  },

  async gerarMinuta(notificacao, modelo, diligencia){
    return Http.get(`${path}/${notificacao}/${modelo}/minuta${diligencia ? '/' + diligencia : ''}`);
  },

  async gerarDto(notificacao, name) {

    function converterDiligenciaEmObj() {
      dto.envolvidos?.map(env => {
        env.enderecos?.map(e => {
          e.diligencias = typeof e?.diligencias === 'string' ? JSON.parse(e?.diligencias || false) || [] : e?.diligencias || [];
          e.diligencias = Utils.orderBy(e.diligencias, 'ordem');
          e.diligencias?.map(d => {
            if(d.usuarioNotificador && typeof d.usuarioNotificador === 'string' ) d.usuarioNotificador = JSON.parse(d.usuarioNotificador);
            if(d.tipoResultado && typeof d.tipoResultado === 'string' ) d.tipoResultado = JSON.parse(d.tipoResultado);
          });
          return e.diligencias;
        });
        return env.diligencias;
      });
    }

    let dto = {}, indices = {quantidade : 0, respondidos: 0};
    let dtoTemp = Utils.clone(notificacao);
    let checklist = await ChecklistProcessamentoBusiness.getChecklists(notificacao, 'notificacao')
    let checklistProcessado = await ChecklistProcessamentoBusiness.processarEntidade(dtoTemp, checklist, null, [], 'storage')
    if(checklistProcessado?.grupos?.length){
      indices = checklistProcessado.indices;
      indices.quantidade = checklistProcessado?.contador?.quantidade || 0;
      indices.respondidos = checklistProcessado?.contador?.respondidos || 0;
    }
    dto = Utils.clone({...notificacao, indices});
    dto.matriculas = dto.matriculas?.filter(e => e).map(e => e.id);
    dto.registrosTds = dto.registrosTds?.filter(e => e).map(e => e.id);
    dto.matriculasExternas = dto.matriculasExternas?.filter(e => e).map(e => e.id);
    dto.protocolos = dto.protocolos?.filter(e => e).map(e => e.id);
    dto.envolvidos = (dto.envolvidos || []).map((envolvido, i) => {
      envolvido.ordem = i + 1;
      return envolvido;
    });

    delete dto.enderecos;

    if(name === 'notificacao-texto') {
      converterDiligenciaEmObj(dto);
    }
    return Utils.clone(dto);
  }

}
